import { Component } from '@angular/core';

@Component({
  selector: 'ui-input-error',
  templateUrl: './input-error.html',
})
export class InputError {}
